'use strict';

const $ = require('jquery');
import Mustache from 'mustache';
//  Mustache = window.Mustache;

// If using the BJ hero elsewhere, we don't need whole campaign JS just for the text animation
// would also gives error if no google maps on the site, etc.
import './campaigns/beautiful-journey/hero-text-carousel';

let hero = {
  getHeroSeason: function() {
    return window.activeSeason || false;
  },
  getContentForSeason: function(season,heroCollections) {
    let retVal;
    if( !season || !heroCollections ) return false;

    for( let i = 0; i < heroCollections.length ; i++ ) {
      if( heroCollections[i].season === season ) {
        retVal = heroCollections[i];
        break;
      }
    }
    return retVal;
  },
  afterHeroRendering: function() {
    let $hero = $('#hero');
    if( $hero.length ) {
      // body.has-hero makes main navigation to be trasparent and on top of the hero
      // $(document.body).toggleClass('has-hero',true); // is set by default
      // body.hero-light changes main navigation color to white

      if( $hero.hasClass('text-light') ) {
        this.setBodyClasses('light');
      } else {
        this.setBodyClasses();
      }

    }

    //        checkInnerCircle();
  },
  setBodyClasses: function(heroStyle) {
    switch(heroStyle) {
    case 'light':
      $(document.body).addClass('has-hero');
      $(document.body).addClass('hero-light');
      break;
    default:
      $(document.body).addClass('has-hero');
      break;
    }
  },
  frontpageHero: function() {
    let template = $('#heroTemplate').html(),
      $placeholderEl = $('[data-hero-id]:first'),
      season = this.getHeroSeason(),
      // heroCollections is an array of hero contents. Each season has it's own content.
      heroCollections = window.heroCollections || null,
      heroContent;

    // Choose hero content
    if( season && heroCollections ) {
      // search for content matching season
      heroContent = this.getContentForSeason(season,heroCollections);
    }

    // if no season-matching content was found, but theres at least some hero-content available, choose first
    if( !heroContent && heroCollections && heroCollections.length ) {
      heroContent = heroCollections[0];
    }

    // render content and place it to page
    if( Mustache && template && heroContent ) {
      $placeholderEl.before(Mustache.render(template,{item: heroContent}));
      $placeholderEl.remove();
      this.afterHeroRendering();
    }

  },
  init: function() {
    if( $(document.body).hasClass('home') ) {
      this.frontpageHero();
    }
  }
};

export default hero;
